export class SystemError extends Error {
  constructor(
    message: string,
    public additionalInfo?: { tags?: Record<string, string | number | undefined>; [other: string]: unknown }
  ) {
    super(message);
    this.name = 'SystemError';
    this.message = message;
    this.additionalInfo = additionalInfo || {};
  }
}
